module.exports = __webpack_public_path__ + "static/media/inactive_tick.f73f2d63.svg";